<template>
  <div>
    <ml-table bordered :data-source="dataSource" :columns="columns">
      <template slot="actions" slot-scope="text, record">
        <a-popconfirm
          v-if="dataSource.length"
          :title="$t('page_mdc_setting_sure_delete')"
          @confirm="() => onDelete(record.key)"
        >
          <a href="javascript:;">{{$t('delete')}}</a>
        </a-popconfirm>
      </template>
      <template slot="code" slot-scope="text, record">
        <a-select 
        show-search
        optionFilterProp="children"
        :value="text" @change="e => handleChange(e, record.key)" style="width: 100%;">
          <template v-for="(item,index) in maintainItemList">
            <a-select-option :value="item.code" :key="index">
              {{ item.code }}
            </a-select-option>
          </template>
        </a-select>
      </template>
    </ml-table>
    <a-button type="primary" style="width: 100%;margin-top: 8px;" @click="handleAdd()">{{ $t('page_plan_maintenance_add_program') }}</a-button>
  </div>
</template>

<script>
const columns = [
  {
    title: 'actions',
    dataIndex: 'actions',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'actions'}
  },
  {
    title: 'page_plan_maintenance_maintenance_item_code',
    dataIndex: 'code',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'code'}
  },
  {
    title: 'page_plan_maintenance_items',
    dataIndex: 'name',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_maintenance_requirements',
    dataIndex: 'requirement',
    ellipsis: true,
    width: 150
  },
  {
    title: 'remark',
    dataIndex: 'remark',
    ellipsis: true,
    width: 150
  }
]
export default {
  data(){
    return {
    }
  },
  props:{
    dataSource:{
      type: Array,
      default: () => ([])
    },
    maintainItemList:{
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  methods:{
    onDelete(key) {
      this.$emit('onDelete',key)
    },
    handleAdd() {
      this.$emit('handleAdd')
    },
    handleChange(value, key) {
      this.$emit('handleChange', value, key)
    },
  }
}
</script>

<style>

</style>